import React from "react";
import { useApp } from "../../../contexts";
import { AddressTruncate } from "../../../components/AddressTruncate";
import CopyToClipboard from "react-copy-to-clipboard";
import * as Notification from "../../../Notification";

export const AddressItemMobile = (props) => {
  const { item, onDelete, onEdit } = props;
  const { T } = useApp();
  return (
    <>
      <div className="py-[1px] flex justify-between items-center">
        <div className="flex flex-col">
          <div className="flex justify-between items-center">
            <div
              className="text-black font-semibold text-sm leading-6 truncate hover:underline hover:underline-offset-1"
              onClick={() => onEdit(item)}
            >
              {item?.name}
            </div>
          </div>
          <div className="flex justify-between items-center">
            <div className="w-[114px] flex items-center gap-[6px]">
              <AddressTruncate
                textStyle={{ fontWeight: 400, fontSize: 15, lineHeight: "20px" }}
                textCss={"hover:underline hover:underline-offset-1"}
                textAction={() => onEdit(item)}
                cutText={true}
                splitFont={4}
                numDot={4}
                text={item?.address}
              />
            </div>
          </div>
        </div>
        <div className="w-[200px] flex justify-end gap-2">
          <CopyToClipboard
            onCopy={() => {
              Notification.success(T("Copied"));
            }}
            text={item?.address}
          >
            <svg
              width="25"
              height="26"
              viewBox="0 0 25 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.33301 9.11328V7.02995C8.33301 4.72876 10.1985 2.86328 12.4997 2.86328L18.7497 2.86328C21.0509 2.86328 22.9163 4.72876 22.9163 7.02995V13.2799C22.9163 15.5811 21.0509 17.4466 18.7497 17.4466H16.6663M8.33301 9.11328H6.24967C3.94849 9.11328 2.08301 10.9788 2.08301 13.2799V19.5299C2.08301 21.8311 3.94849 23.6966 6.24967 23.6966H12.4997C14.8009 23.6966 16.6663 21.8311 16.6663 19.5299V17.4466M8.33301 9.11328H12.4997C14.8009 9.11328 16.6663 10.9788 16.6663 13.2799V17.4466"
                stroke="#1C274C"
                strokeWidth="1.74107"
                strokeLinejoin="round"
              />
            </svg>
          </CopyToClipboard>

          <div>
            <div
              className="flex justify-center"
              onClick={() => onDelete(item)}
            >
              <svg
                width="20"
                height="23"
                viewBox="0 0 20 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.5 4.7793L16.8803 14.8044C16.7219 17.3657 16.6428 18.6464 16.0008 19.5672C15.6833 20.0224 15.2747 20.4066 14.8007 20.6953C13.8421 21.2793 12.559 21.2793 9.99274 21.2793C7.42312 21.2793 6.1383 21.2793 5.17905 20.6942C4.7048 20.405 4.296 20.0201 3.97868 19.5641C3.33688 18.6419 3.25945 17.3594 3.10461 14.7944L2.5 4.7793"
                  stroke="#222222"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M1 4.7793H19M14.0557 4.7793L13.3731 3.37102C12.9196 2.43555 12.6928 1.96782 12.3017 1.6761C12.215 1.6114 12.1231 1.55384 12.027 1.504C11.5939 1.2793 11.0741 1.2793 10.0345 1.2793C8.96883 1.2793 8.43598 1.2793 7.99568 1.51342C7.8981 1.5653 7.80498 1.62519 7.71729 1.69246C7.32164 1.996 7.10063 2.48085 6.65861 3.45055L6.05292 4.7793"
                  stroke="#222222"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M7.5 15.7793L7.5 9.7793"
                  stroke="#222222"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M12.5 15.7793L12.5 9.7793"
                  stroke="#222222"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddressItemMobile;
